var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"currency"},[(_vm.have_icon)?[_c('img',{attrs:{"src":_vm.src}})]:[_c('b',[_vm._v(_vm._s(_vm.currency_str))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }